import './styles/ECert.scss';
import { System_DeviceOrientationMap } from '../../assets/keyMap';
import { AppContext, ExAppContext } from '../../Context';
import { useContext, useState, useRef, useEffect } from 'react';
import { DebugLogger as dlog } from '../../components/Logger';
import DatabaseInterfaceController from '../../controllers/DatabaseInterfaceController';
import ECerticate from '../../exComponents/ECertificate';
import { isPlatform } from '@ionic/react';
import { Browser } from '@capacitor/browser';
import { pdf, PDFViewer } from '@react-pdf/renderer';
import { Filesystem, Directory, Encoding } from '@capacitor/filesystem';
import { FileOpener } from '@capacitor-community/file-opener';

//classes
import MembershipContract from '../../exClasses/membershipContract';
class AuthorityInfo {
    public name: string = '';
    public signature_url: string = '';
    public authority_type: number = 0; //0 - president, 1 - secretary

    constructor(name: string, signature_url: string, authority_stype: number) {
        this.name = name;
        this.signature_url = signature_url;
        this.authority_type = authority_stype;
    }
}

interface Props {}

const ECert:React.FC<Props> = ({}) => {
    //contexts
    const appContext = useContext(AppContext);
    const exAppContext = useContext(ExAppContext);
    //controllers
    const database = new DatabaseInterfaceController(appContext);
    //refs
    const presidentInfoRef = useRef<AuthorityInfo | null>(null);
    const secretaryInfoRef = useRef<AuthorityInfo | null>(null);

    //watchers
    //test
    useEffect(() => {
        dlog('ECertTest: ' + JSON.stringify(exAppContext.membershipContracts)); 
    }, [exAppContext.membershipContracts]);

    //initialize
    useEffect(() => {
        //for e-cert generation
        database.Queue('fetchECertSignatures', [
            ['fetchECertSignatures', 'true'],
        ]);
    }, []);

    //watch for databaseResultAction
    useEffect(() => {
            if (appContext.databaseActionModeQueue.length > 0 && appContext.databaseResultAction != null) {
                const ExecuteDatabaseResultAction = async () => {
                    const [res, mode] = await appContext.databaseResultAction();
                    switch (mode) {
                        case 'fetchECertSignatures':
                            if (!JSON.stringify(res).includes('_false')) {
                                let resObjs = [] as any[];
                                try {
                                    resObjs = JSON.parse(res) as any[];
                                } catch {
                                    resObjs = res as any[];
                                }
                                resObjs.map((res: any) => {
                                    if (res['designation'] == '0') {
                                        presidentInfoRef.current = new AuthorityInfo(res['full_name'], res['signature_url'], parseInt(res['designation']));
                                    }
                                    // SetPresidentInfo(new AuthorityInfo(res['full_name'], res['signature_url'], parseInt(res['designation'])));
                                    else {
                                        secretaryInfoRef.current = new AuthorityInfo(res['full_name'], res['signature_url'], parseInt(res['designation']));
                                    }
                                    // SetSecretaryInfo(new AuthorityInfo(res['full_name'], res['signature_url'], parseInt(res['designation'])));
                                });
                            } else {
                                console.log('fetchECertSignaturesErr: ' + res);
                            }
                            break;
                    }
                }
                switch (appContext.databaseActionModeQueue[0]) {
                    case 'fetchECertSignatures':
                        ExecuteDatabaseResultAction();
                        break;
                }
            }
        }, [appContext.databaseActionModeQueue, appContext.databaseResultAction]);

    //ui functions
    const OnDownloadECertClicked = async (date: Date | null) => {
        if (
            date
            && presidentInfoRef.current
            && secretaryInfoRef.current
        ) {
            appContext.SetWaitScreenMessage('generating e-certificate\nplease wait');
            appContext.SetWaitScreenShouldShow(true);
            const blob = await pdf(<ECerticate presidentInfo={presidentInfoRef.current} secretaryInfo={secretaryInfoRef.current} membership={exAppContext.membership} user={appContext.user} memberTypes={exAppContext.memberTypes} certDate={date} />).toBlob();
            const fileName = 'ppkm-e-certificate-' + exAppContext.membership.memberID + '.pdf';
            if (!isPlatform('hybrid')) {
                const url = URL.createObjectURL(blob);
                Browser.open({ url: url });
                appContext.SetWaitScreenShouldShow(false);
                // const link = document.createElement('a');
                // link.href = url;
                // link.download = fileName;
                // link.click();
                // URL.revokeObjectURL(url); // Clean up
                // appContext.SetPopupMessage('Successfully saved to downloads folder.');
                // appContext.SetWaitScreenShouldShow(false);
            } else {
                const reader = new FileReader();
                reader.readAsDataURL(blob);
                reader.onloadend = async () => {
                    if (reader.result != null) {
                        const base64data = reader.result.toString().split(',')[1];
                        await DownloadEcert(fileName, base64data);
                    }
                };
            }
        } else {
            appContext.SetPopupMessage('Failed to generate e-certificate,\nPlease try again.');

            if(!date)
                console.log('failedToGenerateEcertErr dateErr');
            if(!presidentInfoRef.current)
                console.log('failedToGenerateEcertErr presidentInfoErr');
            if(!secretaryInfoRef.current)
                console.log('failedToGenerateEcertErr secretaryInfoErr');
        }
    }
    const DownloadEcert = async (fileName: string, base64String: string) => {

        if (isPlatform('hybrid')) {
            const uri = await SaveFileToLocal(Directory.Cache, base64String, fileName);
            // const SaveFile = async () => {
            //     try {
            //         // await Mediastore.saveToDownloads({
            //         //     path: uri,
            //         //     filename: fileName
            //         // }).then((res: any) => {
            //         //     console.log('saveToDownloadRes: ' + JSON.stringify(res));
            //         // }).catch((err: string) => {
            //         //     console.log('saveToDownloadsErr: ' + err);
            //         // });
            //         // appContext.SetPopupMessage('Successfully saved to downloads folder.');
            //         Browser.open({ url: uri });
            //         appContext.SetWaitScreenShouldShow(false);
            //     } catch (err: any) {
            //         console.log('getUriErr: ' + JSON.stringify(err));
            //         appContext.SetPopupMessage('Fail to download picture.');
            //     }
            // }
            // await SaveFile();
            //open file 
            // console.log('checkuri: ' + uri);
            await FileOpener.open({
                filePath: uri,
                contentType: 'application/pdf',
            })
        } else {
            var a = document.createElement("a"); //Create <a>
            a.href = "data:image/png;base64," + base64String; //Image Base64 Goes here
            a.download = fileName; //File name Here
            a.click(); //Downloaded file
            console.log('shouldDownloadImage');
        }
        appContext.SetWaitScreenShouldShow(false);
    }

    //exe functions
    const GetCertYearsFromMembershipContract = (contract: MembershipContract) => {
        return contract.min_term?.getFullYear().toString();
    }
    const SaveFileToLocal = async (directory: Directory, base64String: string, fileName: string) => {
        await Filesystem.writeFile({
            path: fileName,
            data: base64String, // your data to write (ex. base64)
            directory: /*Directory.Documents ---not working android 10 onwards*/Directory.Cache,
            recursive: true
        });
        const uri = await Filesystem.getUri({
            directory: directory,
            path: fileName
        });

        if (uri)
            return uri.uri;
        else
            return '';
    }

    //sort functions
    const SortMembershipContractsByMinTerm = (contracts: MembershipContract[]) => {
        const sorted = [] as MembershipContract[];
        contracts.map((contract: MembershipContract) => {
            let isSorted = false;
            sorted.map((sort: MembershipContract, i: number) => {
                if(
                    !isSorted
                    && (contract.min_term && sort.min_term)
                    && (contract.min_term > sort.min_term)
                ) {
                    sorted.splice(i, 0, contract);
                    isSorted = true;
                }
            });

            if(!isSorted) {
                sorted.push(contract);
            }
        });

        return sorted;
    }

    return(
        <div className={'ECert ' + (appContext.deviceOrientation == System_DeviceOrientationMap.LANDSCAPE ? 'landscape' : 'portrait')}>
            {
                SortMembershipContractsByMinTerm(exAppContext.membershipContracts).map((contract: MembershipContract) => {
                    if(contract.min_term) {
                        return(
                            <button className='ECert-btn' onClick={() => { OnDownloadECertClicked(contract.min_term) }}>{GetCertYearsFromMembershipContract(contract)}</button>
                        )
                    }
                })
            }
        </div>
    )
}
export default ECert;